import React, { useEffect, useRef, useState } from "react"
import Carousel from "react-bootstrap/Carousel"
import "bootstrap/dist/css/bootstrap.min.css"
import "./index.scss"

export default function Slider({ slides }) {
  const [activeIndex, setActiveIndex] = useState(0)
  const [isVideoOpen, setIsVideoOpen] = useState(false)
  const [selectedVideoSlide, setSelectedVideoSlide] = useState(null)
  const videoRef = useRef(null)

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex)
  }

  const openVideo = (slide) => {
    if (!slide.videoUrl) return
    setSelectedVideoSlide(slide)
    setIsVideoOpen(true)
  }

  const closeVideo = () => {
    setIsVideoOpen(false)
    setSelectedVideoSlide(null)
  }

  useEffect(() => {
    if (!isVideoOpen) return

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeVideo()
      }
    }

    const previousOverflow = document.body.style.overflow
    document.body.style.overflow = "hidden"
    window.addEventListener("keydown", handleKeyDown)

    return () => {
      document.body.style.overflow = previousOverflow
      window.removeEventListener("keydown", handleKeyDown)
    }
  }, [isVideoOpen])

  useEffect(() => {
    if (!isVideoOpen || !selectedVideoSlide || !videoRef.current) return

    const videoElement = videoRef.current
    videoElement.currentTime = 0

    const playPromise = videoElement.play()
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {
        // Some browsers can still block autoplay; controls remain available.
      })
    }
  }, [isVideoOpen, selectedVideoSlide])

  return (
    <>
      <div className="activities-carousel-wrapper">
        <Carousel
          className="activities-carousel"
          activeIndex={activeIndex}
          onSelect={handleSelect}
          fade
          interval={isVideoOpen ? null : 5000}
          indicators
          controls
          pause="hover"
        >
          {slides.map((slide, index) => (
            <Carousel.Item className="activity-slide" key={slide.id}>
              <div className="activity-image-shell">
                <img
                  className="activity-image"
                  src={slide.imageUrl}
                  alt={slide.titre}
                  loading={index === 0 ? "eager" : "lazy"}
                />
                <div className="activity-image-overlay" aria-hidden="true" />
              </div>
              <Carousel.Caption className="activity-caption">
                <span className="activity-kicker">Activite a la une</span>
                <h3>{slide.titre}</h3>
                <p>
                  {slide.description}
                  {slide.date ? (
                    <>
                      <span className="activity-separator"> - </span>
                      <span className="activity-date">{slide.date}</span>
                    </>
                  ) : null}
                </p>
                {slide.videoUrl ? (
                  <div className="activity-actions">
                    <button
                      type="button"
                      className="activity-video-button"
                      onClick={() => openVideo(slide)}
                    >
                      Voir la video
                    </button>
                    {slide.duration ? (
                      <span className="activity-duration">
                        {slide.duration}
                      </span>
                    ) : null}
                  </div>
                ) : null}
                <div className="activity-meta">
                  <span>{String(index + 1).padStart(2, "0")}</span>
                  <span>/</span>
                  <span>{String(slides.length).padStart(2, "0")}</span>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      {isVideoOpen && selectedVideoSlide ? (
        <div
          className="activity-video-modal"
          role="dialog"
          aria-modal="true"
          aria-label="Video de deliberation de soutenance"
          onClick={closeVideo}
        >
          <div
            className="activity-video-dialog"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="activity-video-close"
              aria-label="Fermer la video"
              onClick={closeVideo}
            >
              Fermer
            </button>

            <video
              ref={videoRef}
              className="activity-video-player"
              autoPlay
              controls
              preload="metadata"
              playsInline
              poster={selectedVideoSlide.imageUrl}
            >
              <source src={selectedVideoSlide.videoUrl} type="video/mp4" />
              Votre navigateur ne supporte pas la lecture video.
            </video>

            <p className="activity-video-caption">
              {selectedVideoSlide.titre}
              {selectedVideoSlide.duration
                ? ` (${selectedVideoSlide.duration})`
                : ""}
            </p>
          </div>
        </div>
      ) : null}
    </>
  )
}
